import _ from 'lodash';
export function getSingleLabel(obj) {
  return obj.value ? `${obj.label}: ${obj.value}` : '';
}
export function getRangeLabel(obj) {
  if (!obj.value) {
    return '';
  }
  let str = obj.label + '：' + obj.value.join('-').replace(/(^-)|(-$)/g, '');
  return obj.value[0] || obj.value[1] ? str : '';
}
export function getOptionLabel({
  props = { label: 'label', value: 'value' },
  multiple = false,
  value,
  options,
  label,
}) {
  if (value === '' || value == undefined || (value && value.length == 0)) {
    return value;
  }

  if (multiple) {
    return _.map(value, (item) => {
      let obj = _.find(options, (option) => {
        return item === option[props.value];
      });
      return `${label}: ${obj ? obj[props.label] : '-'}`;
    });
  } else {
    let labelValue = '';
    _.each(options, (option) => {
      if (value === option[props.value]) {
        labelValue = option[props.label];
      }
      if (props && props.children) {
        let childrens = option[props.children];
        _.each(childrens, (child) => {
          if (value === child[props.value]) {
            labelValue = child[props.label];
          }
        });
      }
    });
    return `${label}: ${labelValue}`;
  }
}
export function removeOptionLabel(obj, index) {
  let _typeof = Object.prototype.toString;
  if (index || index === 0) {
    obj.value.splice(index, 1);
  } else {
    obj.value = '';
    if (_typeof.call(obj.emptyValue) == '[object Null]') {
      obj.value = null;
    } else if (obj.emptyValue == 0) {
      obj.value = 0;
    } else if (obj.emptyValue) {
      obj.value = obj.emptyValue;
    }
  }
  return obj;
}
